(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("preact"));
	else if(typeof define === 'function' && define.amd)
		define(["preact"], factory);
	else if(typeof exports === 'object')
		exports["Autocomplete"] = factory(require("preact"));
	else
		root["Autocomplete"] = factory(root["preact"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__12__) {
return 